// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"cfb85070aea0b5df7cc1","655":"a01f5f27d39f440281bc"}[chunkId] + ".js";
};